import React from "react";
import { HeadingLarge, Subheading } from "~/components/.base/headings";
import { ButtonGroup } from "~/components/.base/buttons";
import Hero from "~/components/.base/hero";
import FoodTruckIcon from "~/images/icons/food_truck.svg";
import ForkKnifeIcon from "~/images/icons/fork_knife.svg";
import defaultImage from "~/images/locations/truck_default.png";
import InstagramIcon from "~/images/icons/location_page/instagram.svg";
import FacebookIcon from "~/images/icons/location_page/facebook.svg";
import TwitterIcon from "~/images/icons/location_page/twitter.svg";
import border from "~/images/background/border_white.png";

import "./DetailHero.scss";

const DetailHero = ({
	city,
	isATruck,
	heroImage,
	facebookLink,
	instagramLink,
	twitterLink,
}) => {
	return (
		<div className="detail-hero">
			<div
				className="hero-container"
				style={{
					backgroundImage: `url(${
						heroImage ? heroImage.fixed.src : ""
					})`,

					backgroundSize: "cover",
					backgroundColor: "#000",
				}}
			>
				<div className="hero-details">
					<Subheading>
						{isATruck ? "Food Truck" : "Restaurant"}
					</Subheading>
					<HeadingLarge>{city}</HeadingLarge>
					<ButtonGroup buttonWidth="200px">
						<button>See Menu</button>
						<button>Cater With Us </button>
						<button>Order Online</button>
					</ButtonGroup>
					<div className="social-icons">
						{facebookLink ? (
							<a href={facebookLink} target="_blank">
								<div className="social-btn">
									<FacebookIcon />
								</div>
							</a>
						) : (
							<div className="social-btn">
								<FacebookIcon />
							</div>
						)}
						{instagramLink ? (
							<a href={instagramLink} target="_blank">
								<div className="social-btn">
									<InstagramIcon />
								</div>
							</a>
						) : (
							<div className="social-btn">
								<InstagramIcon />
							</div>
						)}
						{twitterLink ? (
							<a href={twitterLink} target="_blank">
								<div className="social-btn">
									<TwitterIcon />
								</div>
							</a>
						) : (
							<div className="social-btn">
								<TwitterIcon />
							</div>
						)}
					</div>
				</div>
				<div className="bottom-icon">
					{isATruck ? <FoodTruckIcon /> : <ForkKnifeIcon />}
				</div>
				<img className="border" src={border} alt="border" />
			</div>
		</div>
	);
};

export default DetailHero;
